import { Avatar, IconButton, ListItemIcon, Menu, MenuItem, Stack, Typography } from "@mui/material";
import { useState } from "react";
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from "react-router";
import { useAuthContext } from "@/features/auth/contexts/auth-context"; 

export default function McpHeaderAvatar() {
    const navigate = useNavigate();
    const { authData, logout } = useAuthContext();
    const { nombre, email } = authData;

    const [anchorEl, setAnchorEl] = useState<HTMLElement | undefined>();

    const handleClose = () => setAnchorEl(undefined);

    const handleLogout = async () => {
        await logout();
        navigate("/");
        handleClose();
    }

    return <>
        <Stack direction={"row"} alignItems={"center"} gap={2}>
            <Stack alignItems={"end"} sx={{ display: { xs: "none", sm: "flex" } }}>
                <Typography variant="subtitle2">{nombre}</Typography>
                <Typography color="text.secondary" variant="caption">{email}</Typography>
            </Stack>
            <IconButton onClick={e => setAnchorEl(e.currentTarget)}>
                <Avatar>
                    {nombre.length > 0 ? nombre[0] : "U"}
                </Avatar>
            </IconButton>
        </Stack>
        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
            <MenuItem onClick={handleLogout}>
                <ListItemIcon><LogoutIcon /></ListItemIcon>
                Logout
            </MenuItem>
        </Menu>
    </>
}